class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('[data-product-column]');
    this.loadMoreBtn = document.querySelector('.load-more-btn');
    this.loadMoreContainer = document.querySelector('.load-more-container');
    this.loading = false;

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
      this.setupScrollListener();
    }
  }

  setupScrollListener() {
    let timeout;
    window.addEventListener('scroll', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (this.shouldLoadMore()) {
          this.loadMore();
        }
      }, 200);
    });
  }

  shouldLoadMore() {
    if (this.loading || !this.loadMoreContainer) return false;
    
    const rect = this.loadMoreContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    return rect.top < windowHeight + 200; // 200px before reaching button
  }

  async loadMore() {
    if (this.loading) return;
    
    const nextUrl = this.loadMoreContainer.dataset.nextPage;
    if (!nextUrl) return;

    this.loading = true;
    this.loadMoreBtn.dataset.loading = 'true';
    this.loadMoreBtn.querySelector('.load-more-text').style.display = 'none';
    this.loadMoreBtn.querySelector('.loading-spinner').style.display = 'inline';

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Get new products
      const newProducts = doc.querySelectorAll('[data-product-column] > .col');
      newProducts.forEach(product => {
        this.container.appendChild(product);
      });

      // Update next page URL
      const newLoadMoreContainer = doc.querySelector('.load-more-container');
      if (newLoadMoreContainer && newLoadMoreContainer.dataset.nextPage) {
        this.loadMoreContainer.dataset.nextPage = newLoadMoreContainer.dataset.nextPage;
      } else {
        // No more pages
        this.loadMoreContainer.remove();
        return;
      }

    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.loading = false;
      this.loadMoreBtn.dataset.loading = 'false';
      this.loadMoreBtn.querySelector('.load-more-text').style.display = 'inline';
      this.loadMoreBtn.querySelector('.loading-spinner').style.display = 'none';
    }
  }
}

// Initialize
if (document.querySelector('.load-more-btn')) {
  new InfiniteScroll();
}